<template>
  <div>
    <pop-modal
      :visible="visible"
      title="红字增值税专用发票信息表维护"
      :width="1280"
      :height="100"
      @cancel="handelCancel"
    >
      <div class="wrap">
        <div class="header">
          <div class="left">
            <div><span class="mr-1">开始日期</span><a-date-picker /></div>
            <div class="mt-5"><span class="mr-1">结束日期</span><a-date-picker /></div>
          </div>
          <div class="middle">
            <span class="mr-1">信息表状态</span>
            <a-select style="width: 150px">
              <a-select-option value=""> 全部 </a-select-option>
              <a-select-option value=""> 未上传 </a-select-option>
              <a-select-option value=""> 审核不通过 </a-select-option>
              <a-select-option value=""> 审核通过 </a-select-option>
              <a-select-option value=""> 已核销 </a-select-option>
              <a-select-option value=""> 其他 </a-select-option>
            </a-select>
          </div>
          <div class="right">
            <input type="text" />
            <div class="option-group mt-5">
              <a-button type="primary" ghost v-if="type !== 'other'">查询</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'" @click="upLoad()">上传</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'">撤销</a-button>
              <a-button type="primary" ghost>下载</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'" @click="seeDetail()">查看明细</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'">删除</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'">修改</a-button>
              <a-button type="primary" ghost v-if="type !== 'other'">导出</a-button>
              <a-button type="primary" ghost v-if="type === 'other'" @click="mapDataToInvoice()">选择</a-button>
            </div>
          </div>
        </div>
        <div class="main">
          <m-table
            :filterMultiple="true"
            :pagination="true"
            :pages="pages"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :columns="columns"
            :data-source="sourceData"
            @pro="pro()"
            @next="next()"
            @changeShowCount="changeShowCount"
          >
            <template #operation>
              <a-button @click="openOptionModal('detailed')">明细</a-button>
              <a-button @click="openOptionModal('confirm')">确认</a-button>
              <a-button @click="applyDismiss()">撤销</a-button>
            </template>
          </m-table>
        </div>
      </div>
    </pop-modal>
    <red-invoice ref="redInvoiceModal"></red-invoice>
  </div>
</template>

<script>
import moment from 'moment'
import { parseParam } from '@/utils/util'
import Urls from '@/utils/globel'
import redInvoice from '@/views/redInvoice.vue'

export default {
  components: {
    redInvoice,
  },
  data() {
    return {
      visible: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '信息表流水号',
          dataIndex: 'tabPipeNum',
          width: 100,
        },
        {
          title: '信息表编号',
          dataIndex: 'status',
          width: 100,
        },
        {
          title: '信息表状态',
          dataIndex: '',
          width: 100,
        },
        {
          title: '信息表描述',
          dataIndex: 'tabRemark',
          width: 100,
        },
        {
          title: '发票代码',
          dataIndex: 'taxBillCode',
          width: 100,
        },
        {
          title: '发票号码',
          dataIndex: 'taxBillNo',
          width: 100,
        },
        {
          title: '开票机号',
          dataIndex: 'machineNum',
          width: 100,
        },
        {
          title: '购方名称',
          dataIndex: 'buyerName',
          width: 100,
        },
        {
          title: '购方税号',
          dataIndex: 'buyerTaxpayerId',
          width: 100,
        },
        {
          title: '销方名称',
          dataIndex: 'enterpriseName',
          width: 100,
        },
        {
          title: '销方税号',
          dataIndex: 'enterpriseTaxpayerId',
          width: 100,
        },
        {
          title: '填开日期',
          dataIndex: 'taxBillDate',
          width: 100,
          coustomRender: (v) => {
            moment(v).format('YYYY-MM-DD')
          },
        },
        {
          title: '所属月份',
          dataIndex: 'month',
          width: 100,
        },
        {
          title: '合计金额',
          dataIndex: 'totalGoodsPrice',
          width: 100,
        },
        {
          title: '税率',
          dataIndex: 'taxRate',
          width: 100,
          coustomRender: (v) => {
            return parseFloat(v) * 100 + '%'
          },
        },
        {
          title: '合计税额',
          dataIndex: 'totalTaxPay',
          width: 100,
        },
        {
          title: '经办人',
          dataIndex: 'drawer',
          width: 100,
        },
        {
          title: '申请选择',
          dataIndex: '',
          width: 100,
        },
        {
          title: '申请选择',
          dataIndex: 'applySelect',
          width: 100,
        },
        {
          title: '版本标志',
          dataIndex: 'versionLogo',
          width: 100,
        },
        {
          title: '申请方税号',
          dataIndex: 'applyTaxpayerId',
          width: 100,
        },
        {
          title: '设备编号',
          dataIndex: 'machineCode',
          width: 100,
        },
      ],
      sourceData: [
        {
          taxClass: '0',
          taxBillBuyNum: '9',
          taxBillBuyDate: '1998',
        },
      ],
      pages: {
        total: 0,
        pageIndex: 1,
        totalPage: 0,
        showCount: 10,
        currentPage: 1,
        index: -1,
      },
      type: '',
    }
  },
  methods: {
    show(type) {
      this.visible = true
      this.type = type
      this.getRedInvoiceList()
    },
    handelCancel() {
      this.visible = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async getRedInvoiceList() {
      const params = parseParam({
        showCount: this.pages.showCount,
        currentPage: this.pages.currentPage,
      })
      const res = await this.$http.get(`${Urls.getRedInvoiceList}&${params}`)
      if (res.statusCode === '200') {
        this.sourceData = res.data
        this.pages.total = res.total
        this.pages.totalPage = res.totalPage
      }
    },
    pro() {
      if (this.pages.currentPage > 1) {
        this.pages.currentPage--
        this.getRedInvoiceList()
      }
    },
    next() {
      if (this.pages.currentPage < this.pages.totalPage) {
        this.pages.currentPage++
        this.getRedInvoiceList()
      }
    },
    changeShowCount(val) {
      this.pages.showCount = val
      this.pages.currentPage = 1
      this.getRedInvoiceList()
    },
    // 上传
    async upLoad() {
      if (this.selectedRowKeys.length === 0) {
        this.$info('至少选择一项')
        return
      }
      const params = parseParam({
        invoiceId: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.post(`${Urls.updateRedInvoice}&${params}`)
      this.$succeess({
        title: '提示',
        content: res.msg,
      })
      this.getRedInvoiceList()
      this.selectedRowKeys = []
    },
    // 查看明细
    seeDetail() {
      if (this.selectedRowKeys.length === 0) {
        this.$info('至少选择一项')
        return
      }
      const invoiceId = this.selectedRowKeys[0].id
      this.$refs.redInvoiceModal.seeRedInvoiceDetail(invoiceId)
    },
    // 选择
    async mapDataToInvoice() {
      if (this.selectedRowKeys.length === 0) {
        this.$info('至少选择一项')
        return
      }
      if (this.selectedRowKeys.length > 1) {
        this.$info('请选择一项，不能多选')
        return
      }
      const params = {
        taxBillCode: this.selectedRowKeys[0].taxBillCode,
        taxBillNo: this.selectedRowKeys[0].taxBillNo,
        tabPipeNum: this.selectedRowKeys[0].tabPipeNum,
      }
      this.handelCancel()
      this.$emit('mapDataToInvoice', 'xxbkj', params)
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  .right {
    flex: 0.9;
    input {
      width: 100%;
      line-height: 30px;
    }
    .option-group {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
